import React from 'react';
import { ImageField } from 'react-admin';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  image: {
    maxHeight: '5rem',
  },
};

const CoverGridItem = props => {
  return <ImageField {...props} />;
};

export default withStyles(styles)(CoverGridItem);



// WEBPACK FOOTER //
// ./src/components/ImageGridField/index.js